import React, { useState, useEffect } from "react"
import Select from "react-select"
import Modal from "react-modal"
import { ResponsiveTable, InfoModal, MobileImportantMessage } from "pharedata-responsive-components"

import TimePickerLibrary from "../../TimePickerLibrary"

import { getTanquesSifoneadosWithLocalNumberCierreDiarioMobileData } from '../../utils/tanquesSifoneados'
import { SingleOption, customStyles, parseBudat, getLocaleStringNumber, getNumberFromLocalString, getLocaleStringFloat } from "../../utils/utils.js"
import { getAlertIconVentas } from "../../utils/get"
import { getMaterialTitleCierre } from "../../utils/materiales"
import { showGreyBackground, hideGreyBackground, scrollTo } from "../../utils/windows.js"
import { customModalStyles } from "../../utils/styles"

import closeIcon from "../../../assets/img/cross-icon.svg"

const columnsMobile = [
  {"header": "Tanque", "key": "tanque", "showDetailArrow": false},
  {"header": "Material", "key": "material", "showDetailArrow": false},
  {"header": "Medición física (Lts)<br />Proyectada a las 23:59", "key": "medicion_proyectada", "showDetailArrow": true}
]

const columnsTablet = [
  {"header": "Tanque", "key": "tanque", "showDetailArrow": false},
  {"header": "Material", "key": "material", "showDetailArrow": false},
  {"header": "Medición física (Lts) Proyectada a las 23:59", "key": "medicion_proyectada", "showDetailArrow": true}
]

const styles = customModalStyles(20)
styles.content.padding = 0

export const IngresoMedicionesMobile = ({ 
  selectedEds, 
  configuracion, 
  mediciones, 
  valuesChange, 
  limpiar,
  checkStep,
  confirmarEnabled,
  disableMedicion,
  selectedEstadoCierre,
  setStep
}) => {
    const [dataForTable, setDataForTable] = useState([])
    const [detalle, setDetalle] = useState()
    const [detalleSifon1, setDetalleSifon1] = useState()
    const [detalleSifon2, setDetalleSifon2] = useState()

  useEffect(() => {
    if(selectedEds && configuracion && configuracion.TANQUES.length > 0)
      getDataForTable()          
  }, [selectedEds, configuracion, mediciones])

  const getDataForTable = () => {
    const newData = []
    configuracion.TANQUES.filter(tanque=>tanque.ID!=="TAE_RE").map((tanque, key) => {

      const tmpData = getTanquesSifoneadosWithLocalNumberCierreDiarioMobileData(tanque, mediciones)
      if(tmpData)
        newData.push(tmpData)
    })

    setDataForTable(newData)
  }

  const showDetalle = (medicion, key) => {
    const tanque = configuracion.TANQUES.find(t => t.ID === medicion.id)
    setDetalle(tanque)
    if(tanque.SIFON_1 !== ""){
      const tanque1 = configuracion.TANQUES.find(t => t.ID === tanque.SIFON_1)
      setDetalleSifon1(tanque1)
    }
    else{
      setDetalleSifon1()
    }

    if(tanque.SIFON_2 !== ""){
      const tanque2 = configuracion.TANQUES.find(t => t.ID === tanque.SIFON_2)
      setDetalleSifon2(tanque2)
    }
    else{
      setDetalleSifon2()
    }
    showGreyBackground()
    scrollTo(0, 0)
  }

  const closeModal = () => {
    setDetalle()
    setDetalleSifon1()
    setDetalleSifon2()
    hideGreyBackground()
  }

  return (
    <div className={`hide-desktop ${detalle?"min-height-650": ""}`}>
      <div className="show-only-mobile">
        <MobileImportantMessage
          message="El dato de la medición física proyectada a las 23:59, será considerado para el calculo de Fluctuaciones"
        />
      </div>
      <div className="big-subtitle">
        Ingreso de Mediciones
        <hr className="title-separator-line" />
      </div>

      <div className="show-only-mobile">
        <ResponsiveTable 
          columns={columnsMobile}
          data={dataForTable}
          showDetailFunction={showDetalle}
        />
      </div>

      <div className="show-only-tablet">
        <ResponsiveTable 
          columns={columnsTablet}
          data={dataForTable}
          showDetailFunction={showDetalle}
        />
      </div>
      <div className="important-message show-only-tablet">
        <span className="title">Importante:&nbsp;</span>
        <span>
          El dato de la medición física proyectada a las 23:59, será considerado para el calculo de Fluctuaciones
        </span>
      </div>

      <div className="show-only-mobile">
        <button className="main-button hallow mobile-button" onClick={limpiar}>
          Limpiar
        </button>

        <hr className="mobile-sections-separator" />
        <button className="main-button mobile-button" onClick={checkStep} disabled={!confirmarEnabled || disableMedicion || selectedEstadoCierre==="CERRADO"}>
          Confirmar
        </button>

        <button className="main-button hallow mobile-button" onClick={() => setStep(3)}>
          Volver
        </button>
      </div>

      <div className="show-only-tablet responsive-actions-tablet mediciones-tablet-actions">
        <button className="main-button hallow mobile-button ventas-tablet-button" onClick={() => setStep(3)}>
          Volver
        </button>
        <button className="main-button hallow mobile-button ventas-tablet-button" onClick={limpiar}>
          Limpiar
        </button>

        <button className="main-button mobile-button ventas-tablet-button" onClick={checkStep} disabled={!confirmarEnabled || disableMedicion || selectedEstadoCierre==="CERRADO"}>
          Confirmar
        </button>
      </div>


      {detalle &&
        <Modal isOpen={detalle} onRequestClose={closeModal} style={styles} className="responsive-modal">
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Ingreso de Mediciones</h1>
            <button className="mobile-filters__close-btn" onClick={closeModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
          </div>
          <div className="mobile-filters__main-section">
            <div className="mobile-title-extra-space">
              Hora {detalle.TIPO !== "camion"? "Tanque": ""} {detalle.ID}
            </div>

            <TimePickerLibrary 
              initialHour={mediciones[detalle.ID].hora} 
              onSelect={(e) => valuesChange('hora', e, detalle.ID, detalle.ID_MATERIAL)}              
              disabled={detalle.TIPO === 'camion'? true: false}
            />

            <div className="mobile-title-extra-space">
              Medición (Lts)
            </div>
            <input
              className="mobile-input"
              type="text" 
              onChange={(e) => valuesChange('medicion', e.target.value, detalle.ID)} 
              value={mediciones[detalle.ID]?.medicion}
            />

            <div className="mobile-title-extra-space">
              Medición física (Lts) Proyectada a las 23:59
            </div>

            <div className="mobile-disabled-input">{getLocaleStringFloat(mediciones[detalle.ID]?.total)}</div>

            { detalleSifon1 &&
              <>
                <div className="mobile-title-extra-space">
                  Hora {detalleSifon1.TIPO !== "camion"? "Tanque": ""} {detalleSifon1.ID}
                </div>

                <TimePickerLibrary 
                  initialHour={mediciones[detalleSifon1.ID].hora} 
                  onSelect={(e) => valuesChange('hora', e, detalleSifon1.ID, detalleSifon1.ID_MATERIAL)}
                  disabled={detalleSifon1.TIPO === 'camion'? true: false}
                />

                <div className="mobile-title-extra-space">
                  Medición (Lts)
                </div>
                <input
                  className="mobile-input"
                  type="text" 
                  onChange={(e) => valuesChange('medicion', e.target.value, detalleSifon1.ID)} 
                  value={mediciones[detalleSifon1.ID]?.medicion}
                />

                <div className="mobile-title-extra-space">
                  Medición física (Lts) Proyectada a las 23:59
                </div>

                <div className="mobile-disabled-input">{getLocaleStringFloat(mediciones[detalleSifon1.ID]?.total)}</div>
              </>
            }

            { detalleSifon2 &&
              <>
                <div className="mobile-title-extra-space">
                  Hora {detalleSifon2.TIPO !== "camion"? "Tanque": ""} {detalleSifon2.ID}
                </div>

                <TimePickerLibrary 
                  initialHour={mediciones[detalleSifon2.ID].hora} 
                  onSelect={(e) => valuesChange('hora', e, detalleSifon2.ID, detalleSifon2.ID_MATERIAL)}
                  disabled={detalleSifon2.TIPO === 'camion'? true: false}
                />

                <div className="mobile-title-extra-space">
                  Medición (Lts)
                </div>
                <input
                  className="mobile-input"
                  type="text" 
                  onChange={(e) => valuesChange('medicion', e.target.value, detalleSifon2.ID)} 
                  value={mediciones[detalleSifon2.ID]?.medicion}
                />

                <div className="mobile-title-extra-space">
                  Medición física (Lts) Proyectada a las 23:59
                </div>

                <div className="mobile-disabled-input">{getLocaleStringFloat(mediciones[detalleSifon2.ID]?.total)}</div>
              </>
            }
          </div>
           
          <div className="mobile-filters__footer">
            <button className="main-button" onClick={closeModal}>
              Guardar
            </button>
          </div>
        </Modal>
      }

    </div>
  )
}
